import { atom } from "jotai";

import { PatronCancelBooking } from "../types";

export const originalBookingAtom = atom<PatronCancelBooking.Booking | null>(
  null
);
export const currentBookingAtom = atom<PatronCancelBooking.Booking | null>(
  null
);
export const currentModalStepAtom = atom<PatronCancelBooking.ModalStep>({
  type: "CancelBooking",
});
